<template>
    <div id="w3-business-detail">
        <AppBreadCrumb
            :paths="[{ title: $t('whatsappV3.channelDetails') }]"
            :select="true"
            class="visitor-detail-bread-crumb"
        >
        </AppBreadCrumb>

        <div class="route-page-content breadcrumb-content" v-if="channel">
            <SidebarChild
                :items="menuItems"
                :selected-item="currentTab"
                :focusActive="true"
                @selected="(i) => (currentTab = i.key)"
            />
            <div class="page-content-wrapper">
                <div class="toolbar">
                    <div class="left">
                        <IconButton :on-click="() => $router.push('/integrations/whatsapp-v3')">
                            <span class="material-icons"> chevron_left </span>
                        </IconButton>
                        <div class="icon-container">
                            <WhatsappV3 />
                        </div>
                        <div class="name">{{ $t("whatsappV3.channelLabelPrefix") }}: {{ channel.name }}</div>
                    </div>
                    <div class="right">
                        <a-button
                            type="primary"
                            ghost
                            @click="handleResetChannel"
                            :loading="resetLoading"
                        >
                            {{
                                channel && channel.payload && channel.payload.id
                                    ? $t("whatsappV3.reinstall")
                                    : $t("whatsappV3.scanQr")
                            }}
                        </a-button>
<!--                        <a-button type="danger" @click="deleteModal = true"-->
<!--                            >{{ $t("whatsappChannel.deleteChannel") }}-->
<!--                        </a-button>-->
                    </div>
                </div>

                <div v-if="currentTab === 'detail'">
                    <UpdateDetail v-model="channel" />
                </div>
                <div v-if="currentTab === 'visibility'">
                    <Visibility v-model="channel" />
                </div>
                <div v-if="currentTab === 'comparison'" style="padding: 20px">
                    <WhatsappComparison />
                </div>
                <div v-if="currentTab === 'developer'">
                    <DeveloperSettings v-model="channel" />
                </div>
            </div>
        </div>

        <a-modal
            v-model="deleteModal"
            icon="exclamation-circle"
            :title="$t('whatsappV3.deleteChannelTitle')"
            @cancel="deleteModal = false"
        >
            <p>{{ $t("whatsappV3.deleteChannelConfirm") }}</p>
            <template #footer>
                <a-button key="back" @click="deleteModal = false">
                    {{ $t("chatbotv2.dismiss") }}
                </a-button>
                <a-button key="submit" type="danger" @click="deleteCurrentChannel">
                    {{ $t("chatbotv2.delete") }}
                </a-button>
            </template>
        </a-modal>

        <a-modal
            :visible="resetConfirmModal"
            icon="exclamation-circle"
            :title="$t('whatsappV3.resetConfirmTitle')"
            @cancel="resetConfirmModal = false"
        >
            <div class="reset-confirm-content">
                <a-alert type="warning" show-icon class="mb-3">
                    <template #message>
                        <strong>{{ $t("whatsappV3.warning") }}</strong>
                    </template>
                    <template #description>
                        <ul style="margin: 0; padding-left: 20px;">
                            <li>{{ $t("whatsappV3.resetWarning1") }}</li>
                            <li>{{ $t("whatsappV3.resetWarning2") }}</li>
                            <li>{{ $t("whatsappV3.resetWarning3") }}</li>
                        </ul>
                    </template>
                </a-alert>
                <p>{{ $t("whatsappV3.resetConfirmQuestion") }}</p>
            </div>
            <template #footer>
                <a-button key="back" @click="resetConfirmModal = false">
                    {{ $t("chatbotv2.dismiss") }}
                </a-button>
                <a-button key="submit" type="primary" @click="confirmResetChannel" :loading="resetLoading">
                    {{ $t("whatsappV3.confirmReset") }}
                </a-button>
            </template>
        </a-modal>
    </div>
</template>
<script>
import Vue from "vue";
import IconButton from "../../Settings/components/IconButton.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { sendSocketMessage, socketMessageStream } from "../../../../utils/socketStream";
import _ from "lodash";
import ChannelMenu from "./ChannelMenu.vue";
import Visibility from "./Visibility.vue";
import log2 from "../../../../utils/log2";
import WhatsappV3MenuTypes from "./WhatsappV3MenuTypes";
import UpdateDetail from "./UpdateDetail.vue";
import AppBreadCrumb from "../../../../components/common/AppBreadCrumb.vue";
import SidebarChild from "../../../../components/Sidebar/SidebarChild.vue";
import WhatsappIcon from "../../Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import { filter } from "rxjs/operators";
import WhatsappV3 from "../../Chatbot/pages/integrations/svg/specialWhatsappIcon/WhatsappV3.vue";
import WhatsappComparison from "../../../../components/WhatsappComparison.vue";
import { resetWhatsappUnipileChannel } from "../../../../api/channel";
import DeveloperSettings from "../components/DeveloperSettings.vue";

const log = log2("W3ChannelDetail.vue");
export default Vue.extend({
    name: "W3ChannelDetail",
    components: {
        WhatsappV3,
        WhatsappIcon,
        UpdateDetail,
        Visibility,
        ChannelMenu,
        IconButton,
        AppBreadCrumb,
        SidebarChild,
        WhatsappComparison,
        DeveloperSettings,
    },
    data() {
        const path = (_.last(this.$route.path.split("/")) || "detail").toLowerCase().trim();
        const selected = Object.values(WhatsappV3MenuTypes.Items(this)).find((x) => x.key === path);
        return {
            currentTab: selected ? selected.key : "detail",
            loading: false,
            selectedChannelId: this.$route.params.id,
            deleteModal: false,
            channel: null,
            menuItems: WhatsappV3MenuTypes.Items(this),
            resetLoading: false,
            popupWindow: null,
            resetConfirmModal: false,
        };
    },
    computed: {
        ...mapState({
            channels: (state) => state.channel.channels.filter((x) => x.type === "whatsapp-unipile"),
            siteId: (state) => _.get(state.site.site, "_id"),
            user: (state) => state.auth.user,
            site: (state) => state.site.site,
        }),
    },
    methods: {
        ...mapActions({
            listChannels: "channel/listChannels",
            deleteChannel: "channel/deleteChannel",
            updateChannel: "channel/updateChannel",
        }),

        init() {
            console.log("init");

            this.channel = this.channels.find((x) => x._id === this.selectedChannelId);
            this.originalChannel = _.cloneDeep(this.channel);
            this.channel = _.cloneDeep(this.channel);
        },
        changePage(page) {
            this.currentTab = page;
        },
        deleteCurrentChannel() {
            const channel = this.channel;
            this.deleteChannel(channel._id).then(() => {
                this.$router.push("/integrations/whatsapp-v3");
            });
        },
        handleSave() {
            const isValid = true;
            if (isValid) {
                const payload = this.channel;
                this.loading = true;
                this.updateChannel(payload)
                    .then(() => {
                        this.listChannels();
                        this.$message.success(this.$t("whatsappV3.channelUpdateSuccess"));
                        this.originalChannel = _.cloneDeep(this.channel);
                        this.$emit("ok");
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message.error(this.$t("whatsappV3.channelUpdateFailed"));
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        handleResetChannel() {
            this.resetConfirmModal = true;
        },
        async confirmResetChannel() {
            this.resetLoading = true;
            try {
                const response = await resetWhatsappUnipileChannel(this.channel._id);
                this.resetConfirmModal = false;
                await this.listChannels();
                if (response.reconnectUrl) {
                    this.$message.success(this.$t("whatsappV3.reconnectStarting"));
                    this.openOnboardingLinkWithUrl(response.reconnectUrl);
                } else if (response.onboardLink) {
                    this.$message.success(this.$t("whatsappV3.channelResetStarting"));
                    this.openOnboardingLinkWithUrl(response.onboardLink);
                }
            } catch (error) {
                console.error("Reset channel error:", error);
                this.$message.error(this.$t("whatsappV3.resetChannelError"));
            } finally {
                this.resetLoading = false;
            }
        },
        openOnboardingLinkWithUrl(url) {
            try {
                const parsedUrl = new URL(url);
                const width = 1000;
                const height = 800;
                const left = (window.screen.width - width) / 2;
                const top = (window.screen.height - height) / 2;

                const features = `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,status=yes,location=no,menubar=no,toolbar=no`;
                this.popupWindow = window.open(parsedUrl.toString(), "WhatsappOnboarding", features);

                const checkWindow = setInterval(() => {
                    if (this.popupWindow && this.popupWindow.closed) {
                        clearInterval(checkWindow);
                        this.popupWindow = null;
                        this.listChannels();
                    }
                }, 500);
            } catch (error) {
                console.error("Geçersiz URL:", error);
                this.$message.error(this.$t("whatsappV3.invalidLinkUrl"));
            }
        },
    },
    async mounted() {
        this.init();
    },
    watch: {
        channels: {
            handler() {
                this.init();
            },
            deep: true,
        },
        channel: {
            handler: function (val) {
                if (val) {
                    const isChanged = !_.isEqual(val, this.originalChannel);
                    if (isChanged) {
                        log("channel changed=>", val);
                        this.handleSave();
                    }
                }
            },
            deep: true,
        },
        currentTab(value) {
            const selected = Object.values(this.menuItems).find((x) => x.key === value);
            if (selected) {
                this.$router.push(`/integrations/whatsapp-v3/${this.channel._id}/detail/${selected.key}`);
            }
        },
    },
});
</script>

<style scoped lang="scss">
#w3-business-detail {
    display: flex;
    flex-direction: column;
    background: var(--color-bg-default);
    position: relative;
    width: 100%;
    height: 100%;

    .toolbar {
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 50px;
        border-bottom: 1px solid var(--color-border-default);

        .left {
            display: flex;
            align-items: center;
            gap: 5px;

            .name {
                font-size: 18px;
                font-weight: 700;
            }

            .icon-container {
                width: 30px;
                height: 30px;
                display: flex;
                margin: 0 auto;
                align-items: center;
                justify-content: center;
                border-radius: 6px;
                overflow: hidden;
                position: relative;
                background: #58ca64;
                padding: 10px;
            }
        }

        .right {
            display: flex;
            justify-content: flex-end;
            gap: 5px;
        }
    }
}
</style>
